<p-toast></p-toast>

<div class="execution-draft-dialog" *ngIf="!loading && preview; else busy">
  <section class="execution-context-card">
    <div class="execution-source-summary">
      <span class="summary-icon"><i class="pi pi-shopping-cart"></i></span>
      <div>
        <small>{{ data.orderId ? 'EXECUTION IMPORT' : 'EXECUTION BILLING' }}</small>
        <strong>{{ preview.source.sourceNumber || data.sourceLabel }}</strong>
        <span>{{ data.orderId ? 'Select newly discovered charges to add to the draft.' : 'Review suggested charges before creating an editable sales order.' }}</span>
      </div>
    </div>

    <div class="execution-context-fields">
      <div class="party-source-field">
        <span class="field-label">Party source <em>CRM preferred</em></span>
        <div class="party-source-actions" role="group" aria-label="Party source">
          <p-button label="CRM" icon="pi pi-star-fill" size="small" [outlined]="partySource !== 'CRM'"
            (onClick)="selectPartySource('CRM')"></p-button>
          <p-button label="Legacy" icon="pi pi-history" size="small" severity="secondary" [outlined]="partySource !== 'LEGACY'"
            (onClick)="selectPartySource('LEGACY')"></p-button>
        </div>
      </div>

      <ng-container *ngIf="partySource === 'CRM'; else legacyParty">
        <p-inputgroup class="execution-field">
          <p-inputgroup-addon><i class="pi pi-building"></i></p-inputgroup-addon>
          <p-iftalabel>
            <p-select inputId="executionCrmClient" [options]="clients" [(ngModel)]="crmClientId" optionValue="id"
              optionLabel="companyName" [filter]="true" filterBy="companyName,customerNameLocal,clientNumber,primaryEmail,phoneNumber"
              [showClear]="true" appendTo="body" placeholder="Select CRM client" styleClass="w-full"
              (onChange)="onCrmClientChange()"></p-select>
            <label for="executionCrmClient">CRM client</label>
          </p-iftalabel>
        </p-inputgroup>
        <p-inputgroup class="execution-field">
          <p-inputgroup-addon><i class="pi pi-briefcase"></i></p-inputgroup-addon>
          <p-iftalabel>
            <p-select inputId="executionCrmAccount" [options]="accounts" [(ngModel)]="crmAccountId" optionValue="id"
              optionLabel="companyName" [filter]="true" filterBy="companyName,category" [showClear]="true"
              [disabled]="!crmClientId" appendTo="body" placeholder="No account" styleClass="w-full"
              (onChange)="loadPreview()"></p-select>
            <label for="executionCrmAccount">CRM account</label>
          </p-iftalabel>
        </p-inputgroup>
        <p-inputgroup class="execution-field">
          <p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
          <p-iftalabel>
            <p-select inputId="executionCrmContact" [options]="contacts" [(ngModel)]="crmClientContactId" optionValue="id"
              optionLabel="name" [filter]="true" filterBy="name,email,phone,mobile" [showClear]="true"
              [disabled]="!crmClientId" appendTo="body" placeholder="No contact" styleClass="w-full"
              (onChange)="loadPreview()">
              <ng-template #item let-contact><span>{{ contact.name || contact.email || contact.phone }}</span></ng-template>
              <ng-template #selectedItem let-contact><span>{{ contact?.name || contact?.email || contact?.phone }}</span></ng-template>
            </p-select>
            <label for="executionCrmContact">CRM contact</label>
          </p-iftalabel>
        </p-inputgroup>
      </ng-container>

      <ng-template #legacyParty>
        <p-inputgroup class="execution-field span-2">
          <p-inputgroup-addon><i class="pi pi-history"></i></p-inputgroup-addon>
          <p-iftalabel>
            <p-select inputId="executionLegacyParty" [options]="legacyParties" [(ngModel)]="legacyMainParty"
              optionLabel="entityName" [filter]="true" filterBy="entityName,emailAddress,phoneNumber" [showClear]="true"
              appendTo="body" placeholder="Select legacy company or customer" styleClass="w-full"
              (onChange)="onLegacyPartyChange()">
              <ng-template #item let-party><span>{{ party.entityName }} ({{ party.id.entityType }})</span></ng-template>
              <ng-template #selectedItem let-party><span>{{ party?.entityName }}</span></ng-template>
            </p-select>
            <label for="executionLegacyParty">Legacy company / customer</label>
          </p-iftalabel>
        </p-inputgroup>
        <p-inputgroup class="execution-field">
          <p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
          <p-iftalabel>
            <p-select inputId="executionLegacyContact" [options]="legacyContacts" [(ngModel)]="legacyCustomerId"
              optionValue="id.entityId" optionLabel="entityName" [filter]="true" filterBy="entityName,emailAddress,phoneNumber"
              [showClear]="true" [disabled]="!legacyContacts.length" appendTo="body" placeholder="No contact" styleClass="w-full"
              (onChange)="loadPreview()"></p-select>
            <label for="executionLegacyContact">Legacy contact</label>
          </p-iftalabel>
        </p-inputgroup>
      </ng-template>

      <p-inputgroup class="execution-field">
        <p-inputgroup-addon><i class="pi pi-credit-card"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-select inputId="executionPaymentTerm" [options]="paymentTerms" [(ngModel)]="paymentTermId"
            optionLabel="name" optionValue="paymentTermID" [filter]="true" filterBy="name" appendTo="body"
            placeholder="Select payment term" styleClass="w-full" (onChange)="loadPreview()"></p-select>
          <label for="executionPaymentTerm">Payment term</label>
        </p-iftalabel>
      </p-inputgroup>
      <p-inputgroup class="execution-field">
        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-datepicker inputId="executionExpectedDate" [(ngModel)]="expectedDate" dateFormat="dd-M-yy"
            [showIcon]="true" [showButtonBar]="true" appendTo="body" styleClass="w-full" (onSelect)="loadPreview()"></p-datepicker>
          <label for="executionExpectedDate">Expected date</label>
        </p-iftalabel>
      </p-inputgroup>
    </div>
  </section>

  <p-message *ngIf="preview.resolvedCommercialParty" severity="success" styleClass="billing-party-message">
    <span>Billing party: <strong>{{ preview.resolvedCommercialParty.displayName || 'Resolved party' }}</strong></span>
    <p-tag [value]="preview.resolvedPartySource || partySource" [severity]="preview.resolvedPartySource === 'CRM' ? 'success' : 'secondary'"></p-tag>
  </p-message>

  <p-message *ngFor="let warning of preview.warnings" severity="warn" styleClass="execution-message">
    <i class="pi pi-exclamation-triangle"></i><span>{{ warning }}</span>
  </p-message>
  <p-message *ngFor="let conflict of preview.billingConflicts" severity="error" styleClass="execution-message">
    <i class="pi pi-ban"></i><span>{{ conflict.message }}</span>
  </p-message>
  <p-message *ngFor="let order of preview.existingDrafts" severity="info" styleClass="execution-message existing-draft-message">
    <span>Draft <strong>{{ order.orderNumber }}</strong> already exists for {{ order.currencyCode }}.</span>
    <p-button label="Open Sales Order" icon="pi pi-external-link" [text]="true" size="small" (onClick)="openExisting(order.orderId)"></p-button>
  </p-message>

  <section class="currency-card" *ngFor="let group of preview.currencyGroups | keyvalue">
    <header>
      <div><strong>{{ group.key }}</strong><p-tag [value]="group.value.length + ' charge(s)'" severity="info"></p-tag></div>
      <small>Select the execution charges to add to this sales order.</small>
    </header>
    <div class="charge-line" *ngFor="let line of preview.lines; trackBy: trackLine" [class.disabled]="!line.selectable" [hidden]="line.currencyCode !== group.key">
      <p-checkbox [binary]="true" [ngModel]="isSelected(line.sourceKey)" [disabled]="!line.selectable"
        (ngModelChange)="toggle(line, $event)"></p-checkbox>
      <div class="line-main">
        <strong>{{ line.description || line.operationalCode }}</strong>
        <small>{{ line.originModule }} · {{ line.sourceResourceNumber || line.sourceResourceId }}</small>
        <span class="line-warning" *ngFor="let warning of line.warnings">{{ warning }}</span>
      </div>
      <div class="mapping">
        <span>{{ productLabel(line) }}</span>
        <p-select *ngIf="!line.selectable" [options]="products" optionLabel="name" optionValue="productID" [filter]="true"
          filterBy="productCode,name" appendTo="body" placeholder="Choose service product" styleClass="w-full"
          (onChange)="mapProduct(line, $event.value)">
          <ng-template #item let-product><span>{{ product.productCode }} · {{ product.name }}</span></ng-template>
          <ng-template #selectedItem let-product><span>{{ product?.productCode }} · {{ product?.name }}</span></ng-template>
        </p-select>
      </div>
      <div class="amount"><strong>{{ line.quantity | number:'1.0-4' }} × {{ line.unitPrice | number:'1.2-4' }}</strong><small>{{ line.currencyCode }} · tax {{ line.taxRate || 0 }}%</small></div>
    </div>
  </section>

  <footer class="execution-dialog-footer">
    <span>{{ selected.size }} charge(s) selected. Multiple currencies create separate drafts.</span>
    <div>
      <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="ref.close()"></p-button>
      <p-button [label]="data.orderId ? 'Import Charges' : 'Create Draft'" icon="pi pi-shopping-cart" [loading]="saving"
        [disabled]="!selected.size || !!preview.billingConflicts.length" (onClick)="submit()"></p-button>
    </div>
  </footer>
</div>

<ng-template #busy>
  <div class="busy"><p-progressSpinner></p-progressSpinner><span>Resolving execution charges…</span></div>
</ng-template>
